import 'core-js/es6/map';
import 'core-js/es6/set';
import 'html5-history-api';

import { includes } from 'lodash';

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(searchElement, fromIndex) {
      return includes(this, searchElement, fromIndex);
    }
  });
}

/*global event*/
/*eslint no-restricted-globals: ["error", "event"]*/
var location = window.history.location || window.location;